import React from 'react'
import styled from 'styled-components'

const InputStyle = styled.div`
  width: 190px;
  height: 30px;
  border: solid 2px #00aeee;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Input = styled.input`
  
  outline: none !important;

  font-size: 18px;
  padding: 10px;
  width: 112px;
  height: 20px;
  border: none;
  background: transparent;
  color: white;
  box-sizing:unset;
`

const MaxBtn = styled.button`
  border-radius: 3px;
  width: 40px;
  height: 20px;
  background: #00aeee;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 10px;
`

const QuantityInputBridgeIn = (props: any) => {

  return (
    <InputStyle>
      <Input step="any" type="number" placeholder="Quantity" onChange={props.onChange} value={props.bridgeInDps} />
      <MaxBtn onClick={props.onClick}>Max</MaxBtn>
    </InputStyle>
  )
}

export default QuantityInputBridgeIn
